import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { FeatureNames } from '@/types/features';

import { useSyncFeatureFlag } from '../useFeatureFlags';

// This hook is used to redirect the user to a specific path when a feature flag is disabled
export const useDisabledFFRedirect = ({
  featureFlag,
  redirectPath,
}: {
  featureFlag: string;
  redirectPath: string;
}) => {
  const { push } = useRouter();

  const featureFlagEnabled = useSyncFeatureFlag(featureFlag as FeatureNames);

  useEffect(() => {
    if (!featureFlagEnabled) push(redirectPath);
  }, [featureFlagEnabled, push]);
};
